"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CustomSection = props => {
  var field = props.field,
    fieldName = field.model.itemId;
  var css = field.model.cssClass,
    shouldHide,
    state = _conditionalRendering.store.getState();
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
    var hideArray = state.hiddenFields;
    if (shouldHide) {
      if (hideArray.indexOf(fieldName) === -1) {
        hideArray.push(fieldName);
      }
    } else {
      if (hideArray.indexOf(fieldName) > -1) {
        hideArray = hideArray.filter(e => e !== fieldName);
      }
    }
    state.hiddenFields = hideArray;
  }
  if (shouldHide) {
    return null;
  } else {
    var _field$fields;
    return /*#__PURE__*/_react.default.createElement("fieldset", {
      name: fieldName,
      className: css
    }, (_field$fields = field.fields) === null || _field$fields === void 0 ? void 0 : _field$fields.map(props.fieldFactory));
  }
};
var _default = exports.default = CustomSection;